import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-testimonials',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.scss',
})
export class TestimonialsComponent {
  readonly testimonials = [
    {
      name: 'Ahmed H.',
      role: 'testimonials.items.ahmed.role',
      initials: 'AH',
      quote: 'testimonials.items.ahmed.quote',
      stars: ['star', 'star', 'star', 'star', 'star'],
    },
    {
      name: 'Sarah K.',
      role: 'testimonials.items.sarah.role',
      initials: 'SK',
      quote: 'testimonials.items.sarah.quote',
      stars: ['star', 'star', 'star', 'star', 'star'],
    },
    {
      name: 'Youssef M.',
      role: 'testimonials.items.youssef.role',
      initials: 'YM',
      quote: 'testimonials.items.youssef.quote',
      stars: ['star', 'star', 'star', 'star', 'star_half'],
    },
  ];
}
